<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="web/equipment/maintain/standard/page"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')" rexiauired>
						<yi_cross_select :component="'web_base_equipment_list'" :max="1"
							:ids.sync="yt.conditions.equipmentIds">
						</yi_cross_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
					</el-form-item>
					<yi_curd_expand_button></yi_curd_expand_button>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<!-- <template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setMaintainType()" type="primary">
					{{$t('xinzeng')}}
				</el-button> 
				<el-button size="mini" @click="yt.showEditDialog('chongzhibaoyangbiaozhun',null,'80%')" plain>
					{{$t('chongzhibaoyangbiaozhun')}}
				</el-button>
			</template> -->
			<!-- 右侧按钮插槽 -->
			<!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<template #baoyangzhouqi="scope">
				<p v-if="scope.row.cycleType==2">
					{{$t(store.state.dictJson['EQUIPMENT_MAINTAIN_TEMPLATE_MODE'][scope.row.maintainType])}}:
					1{{$t('ci')}}/{{scope.row.cycleValue}}个{{$t(store.state.dictJson['CYCLE_TYPE'][scope.row.cycleType])}}
				</p>
				<p v-else>
					{{$t(store.state.dictJson['EQUIPMENT_MAINTAIN_TEMPLATE_MODE'][scope.row.maintainType])}}:
					1{{$t('ci')}}/{{scope.row.cycleValue}}{{$t(store.state.dictJson['CYCLE_TYPE'][scope.row.cycleType])}}
				</p>
			</template>
			<!--操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row);saveCycle()">
							{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/maintain/standard/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" required>
						<!-- <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId"></yi_data_select> -->
						<yi_cross_select :component="'web_base_equipment_list'" :max="1"
							:ids.sync="yt.editObj.equipmentId"></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('baoyangbuwei')" required="required">
						<el-input v-model="yt.editObj.part"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangneirong')" required="required">
						<el-input type="textarea" v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input type="text" v-model="yt.editObj.attention"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangzhouqi')" required="required">
						<el-input :readonly="true" @focus="showAddCycleDialog()" v-model="yt.editObj.cycle"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shangcibaoyangshijian')">
						<yi_time_input :time.sync="yt.editObj.lastMaintainTime" :type="'datetime'"></yi_time_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/equipment/maintain/standard/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" required>
						<yi_cross_select :component="'web_base_equipment_list'" :max="1"
							:ids.sync="yt.editObj.equipmentId" disabled></yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('baoyangbuwei')" required="required">
						<el-input v-model="yt.editObj.part" disabled></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangneirong')" required="required">
						<el-input type="textarea" v-model="yt.editObj.content"></el-input>
					</el-form-item>
					<el-form-item :label="$t('zhuyishixiang')">
						<el-input type="text" v-model="yt.editObj.attention"></el-input>
					</el-form-item>
					<el-form-item :label="$t('baoyangzhouqi')" required="required">
						<el-input :readonly="true" @focus="showEditCycleDialog()" v-model="yt.editObj.cycle"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shangcibaoyangshijian')">
						<yi_time_input :time.sync="yt.editObj.lastMaintainTime" :type="'datetime'"></yi_time_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required>
						<el-select v-model="yt.editObj.enable">
							<el-option :label="$t('shi')" :value="true"></el-option>
							<el-option :label="$t('fou')" :value="false"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/equipment/maintain/standard/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<template v-if="yt.editObj.action == 'chongzhibaoyangbiaozhun'">
				<div class="dialog-scroller">
					<!-- <yi_cross_select :component="'web_base_equipment_list'" :min="1" :ids.sync="yt.editObj.equipmentIds" multiple
					:isInput="false">
				</yi_cross_select> -->
					<yi_cross_select :component="'web_base_equipment_list'" :ids.sync="yt.editObj.equipmentIds"
						:isInput="false" multiple>
					</yi_cross_select>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/equipment/maintain/standard/reset')"
						type="primary">
						{{$t('quedingchongzhi')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 新增保养周期弹窗 -->
		<el-dialog :show-close="true" :title="$t('baoyangzhouqi')" :visible.sync="isShowAddCycleDialog" width="800px"
			:close-on-click-modal="false" append-to-body="append-to-body">
			<el-form size="mini" :label-width="yt.formLabelWidth">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<!-- 保养类型 (字典) -->
					<el-form-item :label="$t('baoyangleixing')" required="required" label-width="120px" size="mini">
						<yi_dictionary_select clearable="false" :type="'EQUIPMENT_MAINTAIN_TEMPLATE_MODE'"
							:ids.sync="yt.editObj.maintainType">
						</yi_dictionary_select>
					</el-form-item>
				</el-form>
				<!-- 周期 -->
				<el-form-item :label="$t('zhouqi')+'  1/'+$t('ci')" required="required" label-width="125px" size="mini">
					<div style="display: flex;">
						<yi_number_input :min="1" :type="'number'" :start.sync="yt.editObj.cycleValue">
						</yi_number_input>
						<el-col :span="0.95">&nbsp;</el-col>
						<el-select @change="refreshCycleType" id="editCycleSelect" size="mini"
							v-model="yt.editObj.cycleType" style="width: 20px;">
							<el-option v-for="(item,index) in options" :label="item.label" :value="item.value"
								:key="item.value">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeAddCycleDialog();">{{$t("quxiao")}}</el-button>
				<el-button :loading="store.state.global_loading" size="mini" @click="saveCycle()" type="primary">
					{{ $t("baocun") }}
				</el-button>
			</span>
		</el-dialog>
		<!-- 编辑保养周期弹窗 -->
		<el-dialog :show-close="true" :title="$t('baoyangzhouqi')" :visible.sync="isShowEditCycleDialog" width="800px"
			:close-on-click-modal="false" append-to-body="append-to-body">
			<el-form size="mini" :label-width="yt.formLabelWidth">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<!-- 保养类型 (字典) -->
					<el-form-item :label="$t('baoyangleixing')" required="required" label-width="120px" size="mini">
						<yi_dictionary_select clearable="false" :type="'EQUIPMENT_MAINTAIN_TEMPLATE_MODE'"
							:ids.sync="yt.editObj.maintainType">
						</yi_dictionary_select>
					</el-form-item>
				</el-form>
				<!-- 周期 -->
				<el-form-item :label="$t('zhouqi')+'  1/'+$t('ci')" required="required" label-width="125px" size="mini">
					<div style="display: flex;">
						<yi_number_input :min="1" :type="'number'" :start.sync="yt.editObj.cycleValue">
						</yi_number_input>
						<el-col :span="0.95">&nbsp;</el-col>
						<el-select id="editCycleSelect" size="mini" v-model="yt.editObj.cycleType" style="width: 20px;">
							<el-option v-for="(item,index) in options" :label="item.label" :value="item.value"
								:key="item.value">
							</el-option>
						</el-select>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeEditCycleDialog();">{{$t("quxiao")}}</el-button>
				<el-button :loading="store.state.global_loading" size="mini" @click="saveCycle()" type="primary">
					{{ $t("baocun") }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import shift_setting from '@@/pages/web/base/shift/shift_setting'
	export default {
		name: 'web_base_maintain_standard',
		components: {
			shift_setting
		},
		created() {
			setTimeout(() => {
				this.yt.get(1);
			}, 300)
		},
		data() {
			return {
				options: [{
					label: this.$t('nian'),
					value: 1
				}, {
					label: this.$t('yue'),
					value: 2
				}, {
					label: this.$t('zhou'),
					value: 3
				}, {
					label: this.$t('tian'),
					value: 4
				}],
				list: [],
				organizationList: [],
				customerList: [],
				shiftList: [],
				maintainTypeList: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipmentName',
					width: 130
				}, {
					label: 'baoyangbuwei',
					prop: 'part',
					width: 130
				}, {
					label: 'baoyangneirong',
					prop: 'content',
					width: 200
				}, {
					label: 'zhuyishixiang',
					prop: 'attention',
					width: 200
				}, {
					label: 'baoyangzhouqi',
					type: 'slot',
					width: 200
				}, {
					label: 'shangcibaoyangshijian',
					prop: 'lastMaintainTime',
					type: 'time',
					width: 250
				},{
					label:'chuangjianshijian',
					prop:'createTime',
					type:'time',
				}],
				isShowAddCycleDialog: false,
				isShowEditCycleDialog: false,
				labelWidth: "100px",
				timeList: [],
			}
		},

		methods: {
			setMaintainType() {
				if (this.yt.editObj.action == "xinzeng") {
					this.yt.editObj.maintainType = 2;
					this.yt.editObj.cycleType = 2;
					this.yt.editObj.cycleValue = 1;
				}
			},
			// 重置
			clear() {
				this.yt.conditions = {
					pageSize: 10
				}
				this.yt.get(1)
			},
			showAddCycleDialog() {
				this.isShowAddCycleDialog = true;
			},
			showEditCycleDialog() {
				this.isShowEditCycleDialog = true;
			},
			closeAddCycleDialog() {
				this.isShowAddCycleDialog = false;
			},
			closeEditCycleDialog() {
				this.isShowEditCycleDialog = false;
			},
			saveCycle() {
				console.log("Mtype:", this.yt.editObj.maintainType)
				if (this.yt.editObj.maintainType == undefined) {
					// 默认为2(临时保养)
					this.yt.editObj.maintainType = 2;
				}
				this.isShowCycleDialog = false;
				let label = '';
				if (this.yt.editObj.cycleValue == undefined) {
					this.yt.editObj.cycleValue = 1;
				}
				label = '1' + this.$t('ci') + "/" + this.yt.editObj.cycleValue
				console.log("type:", this.yt.editObj.cycleValue)
				if (this.yt.editObj.cycleType == 1) {
					label = label + this.$t('nian')
				}
				if (this.yt.editObj.cycleType == 2) {
					label = label + this.$t('ge') + this.$t('yue')
				}
				if (this.yt.editObj.cycleType == 3) {
					label = label + this.$t('zhou')
				}
				if (this.yt.editObj.cycleType == 4) {
					label = label + this.$t('tian')
				}
				console.log('label:', label);
				this.$set(this.yt.editObj, 'cycle', label)
				// 关闭窗口
				this.isShowAddCycleDialog = false;
				if (this.yt.editObj.action == "xinzeng") {
					//关闭新增保养周期窗口
					this.isShowAddCycleDialog = false;
				}
				if (this.yt.editObj.action == "bianji") {
					//关闭编辑保养周期窗口
					this.isShowEditCycleDialog = false;
				}
			},
			refreshCycleType(e) {
				this.$forceUpdate();
			}
		},
		watch: {

		}
	};
</script>
